import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

import {
  Button,
  Checkbox,
  Form,
  Input,
  notification,
  Col,
  Row,
  Card,
} from "antd";

import apiPostBticino from "../../api/deviceRoom/postBticino";

export default function Bticino(props) {
  const actionBticino = () => {
    apiPostBticino("Bticino", (err, res) => {
      console.log(res);

      if (!err && res.status === "success") {
        props.showMessage(true, { description: res.status });
      } else {
        props.showMessage(false, { description: res.status });
      }
    });
  };

  useEffect(() => {}, []);
  return (
    <div>
      <div>
        <Card>
          <div>ดึงข้อมูล Bticino เข้า Database</div>
          <Button type="primary" onClick={actionBticino}>
            ดึงข้อมูล
          </Button>
        </Card>
      </div>
    </div>
  );
}
